import { Skeleton } from '@mui/material';
import styles from './skeleton.module.css';

const SkeletonPayout = ({ borderBottom = true, isFirst = false }) => {
  return (
    <div className={`row ml-3 mr-1 `}>
      <div
        className={`col-12 ${styles.item} ${borderBottom ? styles.borderBottom : ''} ${
          isFirst ? styles.noTopPadding : ''
        } px-1`}
      >
        <div className='row'>
          <div className='col px-0'>
            <div className='text-tertiary fw-700'>
              <Skeleton variant='text' sx={{ bgcolor: 'grey.900', fontSize: '1rem' }} />
            </div>
            <div className='font-smaller text-secondary'>
              <Skeleton variant='text' sx={{ bgcolor: 'grey.900', fontSize: '.875rem' }} />
            </div>
          </div>
          <div className='col-auto text-right'>
            <div className='text-green fw-500'>
              <Skeleton
                variant='text'
                width={'90px'}
                sx={{ bgcolor: 'grey.900', fontSize: '1rem' }}
              />
            </div>
            <div className='font-small text-secondary'>
              <Skeleton variant='text' sx={{ bgcolor: 'grey.900', fontSize: '.875rem' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonPayout;
